import { LookupState } from '../components/lookup'
import * as actions from './lookup.actions'

export type State = LookupState

const initialState: State = {
  lookups: {
    groups: [],
    languages: [],
    locales: [],
    personLookupFunctions: [],
    personLookupLevels: [],
    personLookupDivisions: [],
  },
  departments: [],
}

export const reducer = (state = initialState, action: actions.default): State => {
  switch (action.type) {
    case actions.GET_LOOKUPS_SUCCESS:
      return {
        ...state,
        lookups: action.payload.lookups,
      }

    case actions.GET_DEPARTMENT_LOOKUPS_SUCCESS:
      return {
        ...state,
        departments: action.payload,
      }

    default:
      return state
  }
}

export const getLookups = (state: State) => state.lookups
export const getDepartments = (state: State) => state.departments

export const getLanguages = (state: State) => getLookups(state).languages
export const getGroups = (state: State) => getLookups(state).groups
export const getLocales = (state: State) => getLookups(state).locales
export const getLevels = (state: State) => getLookups(state).personLookupLevels
export const getFunctions = (state: State) => getLookups(state).personLookupFunctions
export const getDivisions = (state: State) => getLookups(state).personLookupDivisions



// WEBPACK FOOTER //
// ./src/app/core/store/lookup.reducer.ts